import React, { FunctionComponent } from 'react'

import { CeeContentCreate } from '../components/CeeContentCreate/CeeContentCreate'
import { PageLayout } from '../components/PageLayout/PageLayout'

export const CeeCheckCreate: FunctionComponent = () => {
  return (
    <PageLayout title="Vyhledat subjekt v CEE" isContainer>
      <CeeContentCreate isMonitoring={false} />
    </PageLayout>
  )
}

export default CeeCheckCreate
